import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { MomentModule } from '@fredjohnd/ngx-moment';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { RequesterTypeEnum, RequesterTypeString } from '@shared/enum/requester-type.enum';
import { SharedModule } from '@shared/shared.module';
import { selectUserInfoResult } from '@shared/store/selectors/auth-user-info.selector';
import { AppStates } from '@shared/store/state/app.states';
import { AuthUserInfoState } from '@shared/store/state/auth-user-info.state';

import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-requester-card',
  standalone: true,
  imports: [CommonModule, MomentModule, SharedModule],
  templateUrl: './requester-card.component.html',
  styleUrls: ['./requester-card.component.scss']
})
export class RequesterCardComponent {
  @Input() requesterType?: RequesterTypeEnum;
  @Input() storeName?: string;
  @Input() isCreateMode?: boolean = false;
  @Input() requesterName?: string;
  @Input() requestedDate?: string;
  public dateTimeDisplay = environment.dateTimeDisplay;

  private readonly store = inject<Store<AppStates>>(Store);
  readonly userInfoResult$: Observable<AuthUserInfoState> = this.store.select(selectUserInfoResult);

  protected readonly RequesterTypeEnum = RequesterTypeEnum;

  get isDepartment(): boolean {
    return this.requesterType === RequesterTypeEnum.DEPARTMENT;
  }

  get requesterTypeLabel(): string {
    if (this.storeName) return this.storeName;
    return this.requesterType ? RequesterTypeString[this.requesterType] : 'Department';
  }

  displayRequesterName(loggedInDisplayName?: string): string {
    return this.isCreateMode || !this.requesterName?.trim() ? loggedInDisplayName : this.requesterName;
  }
}
